import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const containers = {
    state: {
        containers: null,
        containerInputData: null,
        showAddContainerForm: false,
        showAddContainerModal: false
    },

    mutations: {
        setContainers(state, containers){
            state.containers = containers
        },
        setContainerInputData(state, payload){
            state.containerInputData = payload
        },
        showAddContainerForm(state){
            state.showAddContainerForm = true
        },
        hideAddContainerForm(state){
            state.showAddContainerForm = false
        },
        showAddContainerModal(state){
            state.showAddContainerModal = true
        },
        hideAddContainerModal(state){
            state.showAddContainerModal = false
        }

    },

    actions: {
        getContainers({ commit, rootState, dispatch, state }, page){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/search_containers?page='+page +'&q='+rootState.search)
                    .then(response => {
                        commit('setContainers', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getContainerInputData({ commit, rootState, dispatch }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/containers/create')
                    .then(response => {
                        commit('setContainerInputData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        createNewContainer({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/containers', {
                    reg_nr: formData.serialNr,
                    year: formData.year,
                    volume: formData.volume,
                    company_id: formData.company
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getContainers')
                        commit('hideAddContainerForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        createNewContainerFromModal({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/containers', {
                    reg_nr: formData.serialNr,
                    year: formData.year,
                    volume: formData.volume,
                    company_id: formData.company
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getCleaningInputData')
                        commit('hideAddContainerModal')
                        vm.$Progress.finish()
                        dispatch('setSnackbar', {
                            color: 'green',
                            text: 'Konteiners izveidots'
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        deleteContainer({commit, rootState, dispatch, state}, containerId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/containers/'+containerId)
                    .then(response => {
                        dispatch('getContainers')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        showAddContainerForm({ commit }){
            commit('showAddContainerForm')
        },
        hideAddContainerForm({ commit }){
            commit('hideAddContainerForm')
        },
        showAddContainerModal({ commit }){
            commit('showAddContainerModal')
        },
        hideAddContainerModal({ commit }){
            commit('hideAddContainerModal')
        },
    },
    getters: {
        containers(state){
            return state.containers
        },
        containerInputData(state){
            return state.containerInputData
        },
        showAddContainerForm(state){
            return state.showAddContainerForm
        },
        showAddContainerModal(state){
            return state.showAddContainerModal
        }
    }
}

export default containers